export default __webpack_public_path__ + "static/media/pg-25.f29f096f.jpg";